import { render, staticRenderFns } from "./span.vue?vue&type=template&id=1f120677&"
import script from "../descriptors/span.js?vue&type=script&lang=js&"
export * from "../descriptors/span.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports